// src/pages/Home/index.jsx
import React, { useState, useEffect } from 'react';
import { Button, Space, Typography, Empty, Divider } from 'antd';
import { CalendarOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import PostCard from '../../components/PostCard';
import './index.css';
const { Title, Text } = Typography;

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [searchText] = useState('');
  const [activeTag] = useState('全部');
  const [allTags, setAllTags] = useState(['全部']);

  useEffect(() => {
    // 从 localStorage 获取文章
    const savedPosts = JSON.parse(localStorage.getItem('blogPosts') || '[]');
    setPosts(savedPosts);
    setFilteredPosts(savedPosts);
    
    // 提取所有标签
    const tags = new Set(['全部']);
    savedPosts.forEach(post => {
      post.tags?.forEach(tag => tags.add(tag));
    });
    setAllTags(Array.from(tags));
  }, []);

  const handleDeletePost = (postId) => {
    const updatedPosts = posts.filter(post => post.id !== postId);
    setPosts(updatedPosts);
    setFilteredPosts(updatedPosts.filter(post => {
      const matchesSearch = searchText ? 
        post.title.toLowerCase().includes(searchText.toLowerCase()) ||
        (post.summary && post.summary.toLowerCase().includes(searchText.toLowerCase())) ||
        post.content.toLowerCase().includes(searchText.toLowerCase())
        : true;
      
      const matchesTag = activeTag === '全部' || 
        (post.tags && post.tags.includes(activeTag));
      
      return matchesSearch && matchesTag;
    }));
    
    // 更新 localStorage
    localStorage.setItem('blogPosts', JSON.stringify(updatedPosts));
  };

  return (
    <div 
      className="home-page"
      style={{
        position: 'relative',
        minHeight: '100vh',
        zIndex: 1,
      }}
    >
      {/* 视频背景 */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        <source src={`${process.env.PUBLIC_URL}/ptr.mp4`} type="video/mp4" />
        您的浏览器不支持视频播放。
      </video>
      
      {/* 主页内容 - 半透明效果 */}
      <div 
        className="page-content"
        style={{
          padding: '40px 60px',
          maxWidth: '1200px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.65)', // 85%透明度的白色背景
          borderRadius: '15px',
          backdropFilter: 'blur(8px)', // 毛玻璃效果
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        <div className="page-header">
          <Title level={2}>我的博客</Title>
        </div>
        <Divider />
        <div className="stats-section">
          <Space size="large">
            <div className="stat-item">
              <Text strong style={{ fontSize: '18px' }}>{posts.length}</Text>
              <Text type="secondary">篇文章</Text>
            </div>
            <div className="stat-item">
              <Text strong style={{ fontSize: '18px' }}>{allTags.length - 1}</Text>
              <Text type="secondary">个标签</Text>
            </div>
            <div className="stat-item">
              <Text strong style={{ fontSize: '18px' }}>
                {posts.reduce((sum, post) => sum + (post.viewCount || 0), 0)}
              </Text>
              <Text type="secondary">次阅读</Text>
            </div>
          </Space>
        </div>

        <Divider />

        {filteredPosts.length === 0 ? (
          <Empty 
            description={
              <div>
                <Title level={4}>暂无文章</Title>
                <Text type="secondary">
                  {searchText ? `未找到包含"${searchText}"的文章` : '还没有发布任何文章'}
                </Text>
                <div style={{ marginTop: 16 }}>
                  <Link to="/write">
                    <Button type="primary" icon={<UserOutlined />}>
                      去写第一篇文章
                    </Button>
                  </Link>
                </div>
              </div>
            }
          />
        ) : (
          <div className="posts-list">
            <div className="list-header">
              <Text strong style={{ fontSize: '16px' }}>
                最新文章 ({filteredPosts.length}篇)
              </Text>
              <Link to="/archive">
                <Button type="link">
                  <CalendarOutlined /> 进入归档
                </Button>
              </Link>
            </div>
            
            <div className="posts-container">
              {filteredPosts.map(post => (
                <PostCard
                  key={post.id}
                  post={post}
                  onDelete={handleDeletePost}
                  showActions={true}
                  showSummary={true}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;